var map = {
	"./channel.js": "a24b",
	"./classify.js": "fd88",
	"./game.js": "51be",
	"./living.js": "06ae",
	"./page.js": "c3b2",
	"./perfect.js": "560a",
	"./register.js": "78e2",
	"./search.js": "2219",
	"./tabIndex.js": "5e6b",
	"./user.js": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";